<body class="shipper-config">
  <app-table-header
    [headerText]="headerText"
    [hasRadioButton]="hasRadioButton"
    [radioHeader]="radioHeader"
    [firstOptionValue]="firstOptionValue"
    [firstOptionName]="firstOptionName"
    [secondOptionValue]="secondOptionValue"
    [secondOptionName]="secondOptionName"
    [radioModel]="radioModel"
    [filterDisabled]="!isFilterEnabled"
    [rightPadding]="7"
    [hasExcel]="false"
    [hasFilter]="false"
    [addItemDisabled]="!isAddShipperConfigDisabled"
    (clearFilterEvent)="clearAllFilters()"
    (addItemEvent)="addShipperConfig()"
  ></app-table-header>
  <div class="shipper-config-table-container">
    <!-- Table -->
    <table mat-table [dataSource]="dataSource" class="shipper-config-table">
      <caption>
        Shipper Config
      </caption>

      <!-- Shipper Id -->
      <ng-container matColumnDef="shipperId">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="header"
          class="portCode-headers"
        >
          <app-table-search-component
            [columnName]="COLUMNTEXT.SHIPPER_ID"
            [control]="shipperIdData.formControl"
            [maxLength]="5"
            [textInputWidth]="100"
            [searchIconOffset]="17"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>

        <td
          mat-cell
          *matCellDef="let config; let i = index"
          headers="portCode-headers"
        >
          {{ config.shipperId }}
        </td>
      </ng-container>

      <!-- PKG SLIC -->
      <ng-container matColumnDef="code">
        <th mat-header-cell *matHeaderCellDef class="portCode-headers">
          <ion-row class="th-text md">
            {{ COLUMNTEXT.CODE }}
          </ion-row>
          <ion-row class="search-wrapper md"></ion-row>
        </th>

        <td
          mat-cell
          *matCellDef="let config; let i = index"
          headers="portCode-headers"
          class="left-data-column"
        >
          {{ config.code }}
        </td>
      </ng-container>

      <!-- Country -->
      <ng-container matColumnDef="originCountry">
        <th mat-header-cell *matHeaderCellDef class="portCode-headers">
          <ion-row class="th-text md">
            {{ COLUMNTEXT.ORIGIN_COUNTRY }}
          </ion-row>
          <ion-row class="search-wrapper md"></ion-row>
        </th>

        <td
          mat-cell
          *matCellDef="let config; let i = index"
          headers="portCode-headers"
          class="left-data-column"
        >
          {{ config.origCountry }}
        </td>
      </ng-container>

      <!-- Region -->
      <ng-container matColumnDef="originSlic">
        <th mat-header-cell *matHeaderCellDef class="large-header">
          <ion-row class="th-text md">
            {{ COLUMNTEXT.ORIGIN_SLIC }}
          </ion-row>
          <ion-row class="search-wrapper md"></ion-row>
        </th>

        <td
          mat-cell
          *matCellDef="let config; let i = index"
          headers="region-headers"
          class="left-data-column"
        >
          {{ config.origSlic }}
        </td>
      </ng-container>

      <!-- Actions -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="action-headers">
          <ion-row class="th-text"> {{ CONSTS.ACTIONS }} </ion-row>
          <ion-row class="search-wrapper">
            <div class="search-header-labels"></div>
          </ion-row>
        </th>
        <td
          mat-cell
          *matCellDef="let config; let i = index"
          headers="action-headers"
        >
          <!-- delete operation is still a WIP for back-end and will be disabled until work is completed -->
          <!-- will be set by role from this context -->
          <app-table-action-cell
            [data]="config"
            [hasDeleteButton]="true"
            [hasEditButton]="true"
            [editButtonDisabled]="!canEditDeleteShipperConfig"
            [deleteButtonDisabled]="!canEditDeleteShipperConfig"
            (emitEditButton)="editShipperConfiguration(config, i)"
            (emitDeleteButton)="onRemoveShipperConfig(config.shipperId)"
          ></app-table-action-cell>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>

      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns; let i = index"
      ></tr>

      <tr class="mat-row no-data-row" *matNoDataRow>
        <td
          class="mat-cell no-border message"
          [attr.colspan]="displayedColumns.length"
        >
          <app-no-results-found></app-no-results-found>
        </td>
      </tr>
    </table>
  </div>
  <app-table-pagination [datasource]="dataSource"></app-table-pagination>
</body>
